import $ from 'jquery';
import slick from 'slick-carousel'; // eslint-disable-line no-unused-vars

const loadCarousel = () => {
    const carousel = $('.j-carousel');

    $(carousel).slick({
        infinite: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        dots: true,
        prevArrow: `
            <button class="slick-nav prev" aria-label="Previous image">
                <svg class="fw-icon-sprite slider-icon" role="presentation">
                    <use href="${window.iconSpriteMedium}chevron-left"></use>
                </svg> 
            </button>
        `,
        nextArrow: `
            <button class="slick-nav next" aria-label="Next image">
                <svg class="fw-icon-sprite slider-icon" role="presentation">
                    <use href="${window.iconSpriteMedium}chevron-right"></use>
                </svg> 
            </button>
        `
    });

    $(carousel).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        const nextSlideObj = $(slick.$slides).children();

        for (let i = 0; i < nextSlideObj.length; i += 1) {
            const child = $(slick.$slides[i]).children();

            if (child.css('display') === 'none') {
                nextSlideObj.css('display', 'block');
                nextSlideObj.loadImgOnDemand('data-smithcode', false, true);
            }
        }
    });
};

export default loadCarousel;
